// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "credit_balances".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "credit_balances" table (1:1 with a DB row, on the wire). */
export const creditBalancesAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    balance: z.number(),
    includedCredits: z.number(),
    autoRefillEnabled: z.boolean(),
    autoRefillThreshold: z.number().nullable(),
    autoRefillPackageId: z.string().nullable(),
    lowBalanceAlertThreshold: z.number().nullable(),
    lowBalanceAlertSent: z.boolean(),
    lastRefillAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=creditBalances.js.map